export const toolbarActionMap = {
    H1: {
        icon: "h1",
        blockType: "header-one"
    },
    H2: {
        icon: "h2",
        blockType: "header-two"
    },
    H3: {
        icon: "h3",
        blockType: "header-three"
    },
    H4: {
        icon: "h4",
        blockType: "header-four"
    },
    bold: {
        icon: "bold",
        inlineStyle: "BOLD"
    },
    italic: {
        icon: "italic",
        inlineStyle: "ITALIC"
    },
    underline: {
        icon: "underline",
        inlineStyle: "UNDERLINE"
    },
    strikethrough: {
        icon: "strikethrough",
        inlineStyle: "STRIKETHROUGH"
    },
    "align-left": {
        icon: "align-left",
        blockStyle: { "text-align": null }
    },
    "align-center": {
        icon: "align-center",
        blockStyle: { "text-align": "center" }
    },
    "align-right": {
        icon: "align-right",
        blockStyle: { "text-align": "right" }
    },
    blockquote: {
        icon: "quote",
        blockType: "blockquote"
    },
    "unordered-list": {
        icon: "list",
        blockType: "unordered-list-item"
    },
    "ordered-list": {
        icon: "ordered-list",
        blockType: "ordered-list-item"
    },
    link: {
        icon: "link",
        entityType: "LINK"
    },
    "insert-dash": {
       icon: "dash",
       entityType: "INSERT_DASH"
    },
    "text-color": {
        icon: "palette",
        entityType: "TEXT_COLOR"
    },
    "insert-symbol": {
        icon: "plus-small",
        entityType: "INSERT_SYMBOL"
    }
};
